import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetchData = () => {
  const [showData, setShowData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`);
        setShowData(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  


  return { showData, loading, error };
};

export default useFetchData;